import React from "react";
import { useNavigate } from "react-router-dom";

function Goodbye() {
  const navigate = useNavigate();

  return (
    <div className="page" style={{ textAlign: "center", marginTop: "100px" }}>
      <div className="card" style={{ maxWidth: "500px", margin: "0 auto", padding: "40px" }}>
        <h1 style={{ fontSize: "2rem", marginBottom: "20px" }}>We're sorry to see you go!</h1>
        <p style={{ color: "#4b5563", marginBottom: "30px", lineHeight: "1.6" }}>
          Your account has been deactivated. We've enjoyed having you with us, 
          and your data has been disconnected as requested.
        </p>
        <p style={{ fontWeight: "500", marginBottom: "30px" }}>
          Feel free to come back anytime—your account can be reactivated 
          whenever you're ready.
        </p>
        <button 
          className="primary-btn" 
          onClick={() => navigate("/login")}
        >
          Return to Login
        </button>
      </div>
    </div>
  );
}

export default Goodbye;